
import Vue from 'vue';
import { Modal, ModalPagination } from '@descomplica/vue-components';
import Analytics from '@/helpers/analytics';
import { EVENT_LABELS } from '@/helpers/analytics/labels';

export default Vue.extend({
  components: {
    Modal,
    ModalPagination,
  },
  props: {
    isActive: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isModalActive: this.isActive,
      steps: [
        {
          imgUrl: 'https://classrooms-assets.s3.sa-east-1.amazonaws.com/post-grad/mc-ilustra-1.svg',
          title: this.$t('postgradMicrocertificate.presentationModal.firstStep.title'),
          description: this.$t('postgradMicrocertificate.presentationModal.firstStep.description'),
        },
        {
          imgUrl: 'https://classrooms-assets.s3.sa-east-1.amazonaws.com/post-grad/mc-ilustra-2.svg',
          title: this.$t('postgradMicrocertificate.presentationModal.secondStep.title'),
          description: this.$t('postgradMicrocertificate.presentationModal.secondStep.description'),
        },
        {
          imgUrl: 'https://classrooms-assets.s3.sa-east-1.amazonaws.com/post-grad/mc-ilustra-3.svg',
          title: this.$t('postgradMicrocertificate.presentationModal.thirdStep.title'),
          description: this.$t('postgradMicrocertificate.presentationModal.thirdStep.description'),
        },
      ].map((step, index) => ({ ...step, slotId: `page${index}` })),
    };
  },
  mounted() {
    Analytics.trackEvent(EVENT_LABELS.modalViewed, {
      postgrad_microcertificate_presentation: true,
    });
  },
  methods: {
    onModalClose() {
      this.isModalActive = false;
      this.$emit('md-close');
    },
  },
});
